var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { maskitoTransform } from '@maskito/core';
import { maskitoNumberOptionsGenerator, maskitoParseNumber } from '@maskito/kit';
var DECIMAL_MASK = maskitoNumberOptionsGenerator({
    decimalZeroPadding: true,
    precision: 2,
    thousandSeparator: ',',
});
var WHOLE_NUMBER_MASK = maskitoNumberOptionsGenerator({
    min: 0,
    thousandSeparator: ',',
});
var EIN_MASK = {
    mask: __spreadArray(__spreadArray(__spreadArray([], new Array(2).fill(/\d/), true), ['-'], false), new Array(7).fill(/\d/), true),
};
var VERIFICATION_CODE_MASK = {
    mask: __spreadArray([], new Array(6).fill(/\d/), true),
};
var coerceValue = function (value) { return (typeof value === 'number' ? value.toString() : value); };
var maskDecimal = function (value) {
    return value === 0 || value ? maskitoTransform(coerceValue(value), DECIMAL_MASK) : '';
};
var maskWholeNumber = function (value) {
    return value === 0 || value ? maskitoTransform(coerceValue(value), WHOLE_NUMBER_MASK) : '';
};
var unmaskNumber = function (value) {
    return maskitoParseNumber(coerceValue(value !== null && value !== void 0 ? value : ''), '.');
};
export { DECIMAL_MASK, WHOLE_NUMBER_MASK, EIN_MASK, VERIFICATION_CODE_MASK, 
//
maskDecimal, maskWholeNumber, unmaskNumber, };
